module.exports = __webpack_public_path__ + "img/12.4bd3fbfc.jpg";